import React from "react";
import { connect } from "react-redux";
import { Select } from "../Input/index.js";
import language from "../../language/index.js";
import { Button } from "../Button/index.js";
import { fetchBloodBanks } from "../../utils/queries/bloodBank.js";
import fetchHospitals from "../../utils/queries/hospitalQuery.js";
import { updateReturnedProducts } from "../../utils/queries/return-product.js";

class UpdateReturnProduct extends React.Component {
  state = {
    error: {},
    source: null,
    destination: null,
    facilityOptions: [],
    isLoadingFacilities: false,
    isSubmitting: false,
  };

  componentDidMount() {
    this.preloadFacilityOptions();

    const { item } = this.props;
    if (!item) return;

    this.setState({
      source: item.returnId?.from
        ? { label: item.returnId.from.name, value: item.returnId.from._id }
        : null,
      destination: item.returnId?.to
        ? { label: item.returnId.to.name, value: item.returnId.to._id }
        : null,
    });
  }

  preloadFacilityOptions = async () => {
    this.setState({ isLoadingFacilities: true });
    const [bbResult, hospResult] = await Promise.allSettled([
      fetchBloodBanks(this.props.defaultLanguage, {
        page: 1,
        limit: 200,
        type: "dropdown",
      }),
      fetchHospitals(this.props.defaultLanguage, {
        page: 1,
        limit: 200,
        type: "dropdown",
        isDirectTransfer: true,
      }),
    ]);

    const bloodBanks =
      bbResult.status === "fulfilled" && Array.isArray(bbResult.value)
        ? bbResult.value
        : [];
    const hospitals =
      hospResult.status === "fulfilled" && Array.isArray(hospResult.value)
        ? hospResult.value
        : [];

    this.setState({
      facilityOptions: [...bloodBanks, ...hospitals],
      isLoadingFacilities: false,
    });
  };

  onChangeText = (field, e) => {
    let { error } = this.state;
    delete error[field];
    this.setState({ [field]: e, error });
  };

  validate = () => {
    const { error, source, destination } = this.state;

    if (!source) {
      error.source = language[this.props.defaultLanguage].field_required;
    }
    if (!destination) {
      error.destination = language[this.props.defaultLanguage].field_required;
    }

    this.setState({ error });
    return Object.keys(error).length === 0;
  };

  onSubmit = async () => {
    if (!this.validate()) return;

    const { item } = this.props;
    const { source, destination } = this.state;

    try {
      this.setState({ isSubmitting: true });

      await updateReturnedProducts(this.props.defaultLanguage, {
        id: item._id,
        source: source?.value,
        destination: destination?.value,
      });

      this.setState({ isSubmitting: false });
      this.props.getData && this.props.getData(true);
      this.props.handleCloseModal && this.props.handleCloseModal();
    } catch (error) {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { defaultLanguage } = this.props;
    const lang = language[defaultLanguage];

    return (
      <div className="card-body">
        <form className="row">
          <div className="col-md-6">
            <Select
              options={this.state.facilityOptions}
              isLoading={this.state.isLoadingFacilities}
              placeholder={lang.select}
              label={lang.source}
              value={this.state.source}
              onChange={(e) => this.onChangeText("source", e)}
              error={this.state.error.source}
              required
            />
          </div>
          <div className="col-md-6">
            <Select
              options={this.state.facilityOptions}
              isLoading={this.state.isLoadingFacilities}
              placeholder={lang.select}
              label={lang.destination}
              value={this.state.destination}
              onChange={(e) => this.onChangeText("destination", e)}
              error={this.state.error.destination}
              required
            />
          </div>
          <div className="modal-footer">
            <Button
              text={lang.cancel}
              onPress={(e) => {
                e.preventDefault();
                this.props.handleCloseModal && this.props.handleCloseModal();
              }}
              className="btn-default"
              type="button"
            />
            <Button
              text={lang.submit}
              isSubmitting={this.state.isSubmitting}
              onPress={(e) => {
                e.preventDefault();
                this.onSubmit();
              }}
            />
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(UpdateReturnProduct);
